import { useQuery } from "@apollo/client";
import MailerConfigShowQuery from "../graphql/queries/MailerConfigShowQuery.graphql";
import MailerConfigEditQuery from "../graphql/queries/MailerConfigEditQuery.graphql";

export function useMailerConfigShowQuery(id: string | null, skip = false) {
  return useQuery(MailerConfigShowQuery, {
    variables: { id },
    skip: skip || !id,
  });
}

export function useMailerConfigEditQuery(id: string | null, skip = false) {
  return useQuery(MailerConfigEditQuery, {
    variables: { id },
    skip: skip || !id,
  });
}
